/* eslint-disable indent */
/* eslint-disable */
import React, { useState, useEffect } from "react";
import {
  Table,
  Space,
  Spin,
  Tooltip,
  Button,
  Empty,
  DatePicker,
  message,
  Row,
  Col,
  Card
} from "antd";
import { serialNum } from "../../../utils";
import { useNavigate, useLocation } from "react-router-dom";
import {
  dateFormat_dmy,
  commonSorterForTable,
} from "../../../utils";

import urls from "../../../api/urls";
import API from "../../../api";
import printerIcon from "../../../assests/images/printIcon.svg";
import Smcs_Loader from "../../../assests/images/loader-new.gif";
import UpdateIcon from "../../../assests/images/updateEway.svg";
import moment from "moment";

import search_icon from "../../../assests/images/search-icon.svg";

import "../InScan/style.scss";


const ThreePLWiseManifest = () => {
  const { MANIFEST_CP_LIST, THREE_PL_WISE_MANIFEST } = urls;
  const { RangePicker } = DatePicker;


  const navigate = useNavigate();
  const location = useLocation();
  const [allCps, setAllCps] = useState([]);
  const [manifestDetails, setManifestDetails] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentCpId, setCurrentCpId] = useState(null);
  const [lastDate, setLastDate] = useState({});
  const [dateRangeStatus, setDateRangeStatus] = useState(false);
  const [sortedInfo, setSortedInfo] = useState({});
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0
  });

  // Default date values
  const defaultStartDate = moment().subtract(1, "day").format(dateFormat_dmy);
  const defaultEndDate = moment().format(dateFormat_dmy);
  const defaultDateRange = {
    fromDate: defaultStartDate,
    toDate: defaultEndDate
  };

  const handleTableChange = (pagination, filters, sorter) => {
    setSortedInfo(sorter);
    const { current, pageSize } = pagination;
    getManifestDetails(
      lastDate?.fromDate || moment().subtract(1, "day").format(dateFormat_dmy),
      lastDate?.toDate || moment().format(dateFormat_dmy),
      current - 1,
      pageSize,
      currentCpId
    );
  };

  const columns = [
    {
      title: "Sl No",
      align: "center",
      width: 10,
      render: (a, b, idx) => serialNum(10, 1, idx),
    },
    {
      title: "Manifest ID",
      dataIndex: "manifestId",
      key: "manifestId",
      width: 10,

      render: (text) => <span>{text}</span>,
    },
    {
      title: "Date",
      dataIndex: "date",
      key: "date",
      width: 10,
      sorter: (a, b) => commonSorterForTable(a, b, "date"),
      sortOrder: sortedInfo?.columnKey === "date" ? sortedInfo?.order : null,
      ellipsis: true,
      render: (text) => {
        let parsedDate = moment(text, "YYYY-MM-DD HH:mm:ss");
        let formattedDate = parsedDate?.format("DD-MM-YYYY HH:mm:ss");
        return <div>{formattedDate ? formattedDate : null}</div>;
      },
    },
    {
      title: "No of Shipment(s)",
      width: 10,
      dataIndex: "shipmentCount",
      key: "shipmentCount",
    },
    {
      title: "Total Weight (Kg)",
      dataIndex: "totalWeight",
      key: "totalWeight",
      width: 10,
      render: (text) => <span>{text?.toFixed(2)}</span>,
    },
    {
      title: "Action",
      key: "action",
      fixed: "right",
      width: 20,
      render: (text, record) => (
        <Space size="middle">
          <Button
            className=""
            disabled={!record?.isEwayBillPresent}
            style={{
              borderRadius: "5px",
              color: !record?.isEwayBillPresent ? "#919090" : "#2E77D0",
              background: !record?.isEwayBillPresent ? "#EEEEEE" : "white",
              border: "1px solid",
              padding: "2px 4px",
            }}
            onClick={() =>
              navigate("/cp-wise-Eway/" + record?.manifestId, {
                state: {
                  ...record,
                  cpId: currentCpId,
                  dateRange: lastDate,
                  fromTab: 3,
                },
              })
            }
          >
            <img src={UpdateIcon} />
            <span className="ml-1 fw-500">UPDATE TRANSPORTER ID</span>
          </Button>
          <Button
            className=""
            style={{
              borderRadius: "5px",
              color: !record?.isEwayBillPresent ? "#919090" : "#2E77D0",
              background: !record?.isEwayBillPresent ? "#EEEEEE" : "white",
              border: "1px solid",
              padding: "2px 4px",
            }}
            disabled={!record?.isEwayBillPresent}
            onClick={() =>
              navigate("/print-eway-bill", {
                state: {
                  state: record?.manifestId,
                  key: "VIEW_TRIP",
                  slug: "/generateManifest?tab=3",
                  isCP_EwayBill: true,
                  dateRange: lastDate,
                },
              })
            }
          >
            <span className="fw-500">PRINT</span>
          </Button>
          <Button
            onClick={() =>
              navigate("/cp-wise-manifest-print/" + record?.manifestId, {
                state: {
                  ...record,
                  dateRange: lastDate,
                  fromTab: 3
                },
              })
            }
          >
            <Tooltip title="Print">
              <img src={printerIcon} />
            </Tooltip>
          </Button>
        </Space>
      ),
    },
  ];

  useEffect(() => {
    // getCPDetails();
  }, []);

  // Always reset to defaults on mount (remount)
  useEffect(() => {
    setCurrentCpId(null);
    setLastDate({});
    setDateRangeStatus(false);
    setSortedInfo({});
    setPagination({
      current: 1,
      pageSize: 10,
      total: 0
    });
  }, []);

  // Restore state from navigation DateFilter
  // This handles restoring only the date range state when navigating back to this component
  useEffect(() => {
    if (location.state && location.state.dateRange) {
      // Only restore date range if present
      setLastDate(location.state.dateRange);
      setDateRangeStatus(true);
      getManifestDetails(location.state.dateRange.fromDate, location.state.dateRange.toDate, 0, pagination.pageSize);
    } else {
      setLastDate(defaultDateRange);
      setDateRangeStatus(true);
      getManifestDetails(defaultStartDate, defaultEndDate, 0, pagination.pageSize);
    }
    // else if (allCps?.length > 0) {
    //   // Always set defaults if no navigation state
    //   const defaultCpId = allCps[0]?.cpId;
    //   setCurrentCpId(defaultCpId);
    //   setLastDate(defaultDateRange);
    //   setDateRangeStatus(true);
    //   if (defaultCpId) {
    //     getManifestDetails(defaultStartDate, defaultEndDate, 0, pagination.pageSize, defaultCpId);
    //   }
    // }
    // eslint-disable-next-line
  }, [location.state]);

  useEffect(() => {
    console.log("allCps", allCps);
    // Only set defaults and call getManifestDetails if currentCpId is not already set
    if (allCps?.length > 0 && currentCpId == null) {
      const defaultCpId = allCps[0]?.cpId;
      setCurrentCpId(defaultCpId);
      setLastDate(defaultDateRange);
      setDateRangeStatus(true);
      if (defaultCpId) {
        getManifestDetails(defaultStartDate, defaultEndDate, 0, pagination.pageSize, defaultCpId);
      }
    }
    // If state was restored, fetch data for it
    if (allCps?.length > 0 && currentCpId && lastDate?.fromDate && lastDate?.toDate) {
      getManifestDetails(lastDate.fromDate, lastDate.toDate, 0, pagination.pageSize, currentCpId);
    }
    // eslint-disable-next-line
  }, [allCps, currentCpId]);

  const getManifestDetails = async (
    start = defaultStartDate,
    end = defaultEndDate,
    page = 0,
    size = 10,
  ) => {
    setLoading(true);
    try {
      const formattedStartDate = moment(start, dateFormat_dmy).format("DD-MM-YYYY");
      const formattedEndDate = moment(end, dateFormat_dmy).format("DD-MM-YYYY");

      let activeHub = JSON.parse(localStorage.getItem("active_hub") || "{}");
      let userInfo = JSON.parse(localStorage.getItem("userId") || "{}");
      let hubId = activeHub?.hubId || userInfo?.userInfo?.premiseId;

      let queryParams = `startDate=${formattedStartDate}&endDate=${formattedEndDate}&page=${page}&size=${size}&hubId=${hubId}`;


      let response = await API.Api(
        `${THREE_PL_WISE_MANIFEST}?${queryParams}`
      ).getWithPremiseHeader();

      if (response?.status) {
        //console.log("response", response);
        const { manifests, totalCount } = response?.response?.data || {};
        setManifestDetails(manifests || []);
        setPagination(prev => ({
          ...prev,
          total: totalCount
        }));
      } else {
        message.error(response?.response?.data?.message || "Internal server error.");
      }
    } catch (error) {
      message.error("Failed to fetch manifest details");
    } finally {
      setLoading(false);
    }
  };

  const getCPDetails = async () => {
    setLoading(true);
    try {
      let activeHub = JSON.parse(localStorage.getItem("active_hub") || "{}");
      let userInfo = JSON.parse(localStorage.getItem("userId") || "{}");
      let hubId = activeHub?.hubId || userInfo?.userInfo?.premiseId;

      let response = await API.Api(
        MANIFEST_CP_LIST + hubId
      ).getWithHeader();

      if (response?.status) {
        let data = response?.response?.data;
        setAllCps(data);
      } else {
        message.error(
          response?.response?.data?.message || "Internal server error."
        );
      }
    } catch (error) {
      message.error("Failed to fetch CP details");
    } finally {
      setLoading(false);
    }
  };

  const disabledDate = (current) => {
    return current && current > moment().endOf("day");
  };

  const dateRangeHandle = (e, a) => {
    const newDateRange = {
      fromDate: a[0] || "",
      toDate: a[1] || ""
    };
    setLastDate(newDateRange);
    setDateRangeStatus(a[0]?.length > 0);
  };

  return (
    <>
      <div className="cp-wise-manifest-cntr" style={{ minHeight: "400px" }}>
        <Spin
          spinning={loading}
          indicator={
            <img src={Smcs_Loader} style={{ height: "100px", width: "100px" }} />
          }
        >
          <Card>
            <Row gutter={[16, 16]}>
              <Col xs={24} sm={12} md={16} lg={18}>
                <div className="d-flex justify-content-end">
                  <RangePicker
                    style={{
                      borderRadius: "5px 0 0 5px",
                      height: "40px",
                      width: "230px",
                    }}
                    disabledDate={(current) => disabledDate(current)}
                    onChange={dateRangeHandle}
                    value={[
                      lastDate?.fromDate ? moment(lastDate.fromDate.replaceAll("-", "/"), dateFormat_dmy) : null,
                      lastDate?.toDate ? moment(lastDate.toDate.replaceAll("-", "/"), dateFormat_dmy) : null
                    ]}
                    format={dateFormat_dmy}
                  />
                  <Button
                    className="center"
                    disabled={!dateRangeStatus}
                    style={{
                      width: "40px",
                      height: "40px",
                      border: "1px solid #d9d9d9",
                      borderRadius: "0 5px 5px 0",
                    }}
                    onClick={() => {
                      setPagination(prev => ({ ...prev, current: 1 }));
                      getManifestDetails(
                        lastDate?.fromDate || defaultStartDate,
                        lastDate?.toDate || defaultEndDate,
                        0,
                        pagination.pageSize,
                        currentCpId
                      );
                    }}
                  >
                    <img src={search_icon} />
                  </Button>
                </div>
              </Col>
            </Row>
          </Card>

          {manifestDetails?.length > 0 ? (
            <Table
              onChange={handleTableChange}
              className="table-head-sticky"
              columns={columns}
              dataSource={manifestDetails}
              pagination={{
                ...pagination,
                showSizeChanger: true,
                showTotal: (total) => `Total ${total} items`
              }}
            />
          ) : (
            <Empty description="No manifest data found" />
          )}
        </Spin>
      </div>
    </>
  );
};

export default ThreePLWiseManifest;
